import { render } from "./profileImgChange.vue?vue&type=template&id=fa48cd86&scoped=true"
import script from "./profileImgChange.vue?vue&type=script&lang=js"
export * from "./profileImgChange.vue?vue&type=script&lang=js"

import "./profileImgChange.vue?vue&type=style&index=0&id=fa48cd86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa48cd86"]])

export default __exports__